module.exports = __webpack_public_path__ + "img/slider-review-kynorelly.3fbf7b06.webp";